module.exports = __webpack_public_path__ + "img/about-img-1.f2d10300.jpg";